module.exports = __webpack_public_path__ + "static/media/robosgdemo2.7a8581ac.jpeg";